import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { clarity } from 'react-microsoft-clarity';
import './index.css';

clarity.init('qq4sj31isg');

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')  
);
